(function () {
  if (window.__cnGoalBarWired) return;
  window.__cnGoalBarWired = true;

  // Previous snapshot, so we can react to the cart *increasing* and to the goal
  // being newly reached (vs. just rendering the current state).
  var prevTotal = null, prevReached = false, bumpTimer = null;

  function getConfig() {
    var el = document.getElementById('cn-goal-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Format cents -> "$80" / "$12.50" (drops a trailing .00, like Liquid's
  // money_without_trailing_zeros). Store currency is USD.
  function money(cents) {
    if (cents < 0) cents = 0;
    var s = (Math.round(cents) / 100).toFixed(2);
    return '$' + s.replace(/\.00$/, '');
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Glow-highlight "free shipping" + the dollar amount. Mirrors the Liquid build
  // so JS updates keep the same look (case-insensitive here).
  function decorate(text, amount) {
    var html = esc(text).replace(/free shipping/gi, '<span class="cn-goal__hl">$&</span>');
    if (amount) {
      var a = esc(amount);
      html = html.split(a).join('<span class="cn-goal__hl cn-goal__hl--amt">' + a + '</span>');
    }
    return html;
  }

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // Publish the bar's height so the sticky (on-scroll-up) header can sit just
  // below it instead of overlapping. Re-measured on resize / font load.
  function measureHeight() {
    var bar = document.querySelector('[data-cn-goal]');
    if (!bar) return;
    document.documentElement.style.setProperty('--cn-goal-h', bar.offsetHeight + 'px');
  }

  function setReached(bar, reached) {
    bar.querySelectorAll('[data-cn-goal-dot="ship"]').forEach(function (node) {
      node.classList.toggle('is-reached', !!reached);
    });
  }

  // Brief glow surge on the fill when the cart total goes up.
  function flashBump(bar) {
    bar.classList.remove('is-bump');
    void bar.offsetWidth; // force reflow so the animation can restart
    bar.classList.add('is-bump');
    clearTimeout(bumpTimer);
    bumpTimer = setTimeout(function () { bar.classList.remove('is-bump'); }, 720);
  }

  // Pop + expanding ring on the emblem when the goal is reached.
  function pingEmblem(bar) {
    var dot = bar.querySelector('[data-cn-goal-dot="ship"]');
    if (!dot) return;
    dot.classList.remove('just-reached');
    void dot.offsetWidth;
    dot.classList.add('just-reached');
    setTimeout(function () { dot.classList.remove('just-reached'); }, 880);
  }

  function update() {
    var cfg = getConfig();
    var bar = document.querySelector('[data-cn-goal]');
    if (!cfg || !bar) return Promise.resolve();
    return readCart().then(function (cart) {
      var total = cart.total_price; // cents, after line discounts
      var cap = cfg.shipCents > 0 ? cfg.shipCents : 1;
      var near = cfg.nearCents || 2500;
      var fillPct = Math.min(100, (total / cap) * 100);

      var fillEl = bar.querySelector('[data-cn-goal-fill]');
      if (fillEl) fillEl.style.width = fillPct + '%';
      var cometEl = bar.querySelector('[data-cn-goal-comet]');
      if (cometEl) cometEl.style.left = fillPct + '%';

      var reached = total >= cfg.shipCents;
      setReached(bar, reached);

      // React to change (skip the very first paint so the page doesn't flash).
      if (prevTotal !== null) {
        if (total > prevTotal) flashBump(bar);
        if (reached && !prevReached) pingEmblem(bar);
      }
      prevTotal = total;
      prevReached = reached;

      // Escalating, proximity-aware copy. The "near" + zero-state variants are
      // generated here (not theme settings) — keep in sync with the Liquid.
      var msg, tier, rem = '', remCents = 0, nearActive = false;
      if (reached) {
        tier = 'success';
        msg = cfg.msgSuccess;
      } else {
        tier = 'shipping';
        remCents = cfg.shipCents - total;
        rem = money(remCents);
        if (total <= 0) {
          msg = cfg.msgShipping;
        } else if (remCents <= near) {
          nearActive = true;
          msg = 'Almost there — ' + rem + ' from free shipping';
        } else {
          msg = 'Only ' + rem + ' from free shipping';
        }
      }

      bar.setAttribute('data-tier', tier);
      bar.classList.toggle('is-near', nearActive);

      var labelEl = bar.querySelector('[data-cn-goal-prizelabel]');
      if (labelEl) labelEl.textContent = reached ? 'Unlocked' : 'Free shipping';

      var msgEl = bar.querySelector('[data-cn-goal-msg]');
      if (msgEl) msgEl.innerHTML = decorate(msg, rem);
    }).catch(function () {});
  }

  // React to cart writes made anywhere on the page. No MutationObserver — the
  // old shipping-unlock bar froze the browser by observing its own re-renders.
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    url = String(url);
    var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var p = origFetch.apply(this, args);
    if (isCartWrite) {
      p.then(function () { setTimeout(update, 160); }).catch(function () {});
    }
    return p;
  };

  // Some themes still post cart changes over XHR (Ajax add-to-cart libs).
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url))) {
        this.addEventListener('load', function () { setTimeout(update, 160); });
      }
    } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  // Pub/sub used by Dawn-based themes.
  document.addEventListener('cart:updated', function () { setTimeout(update, 80); });
  document.addEventListener('cart:refresh', function () { setTimeout(update, 80); });

  window.addEventListener('resize', measureHeight);
  window.addEventListener('load', measureHeight);

  function init() {
    measureHeight();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
